module.exports = __webpack_public_path__ + "fonts/iconfont.02bce757.ttf";